module.exports = __webpack_public_path__ + "static/tape-info-cdc335911fe1a37f813af14193077212.webp";